<template>
  <div class="this-confidentiality-rules">
    <h1>Règles de confidentialité applications mobiles Google Play & Appstore</h1>

    Les applications mobiles CodePanda disponibles sur les plateformes Google Play et AppStore. En téléchargeant l’une de ses applications vous acceptez les conditions relatives à cette application mobile.

    Aucune information n'est collectée. Ni email, ni position gps, rien...

    Vous pouvez nous contacter pour toutes informations ou toutes questions sur notre adresse : contact@code-panda.fr
  </div>
</template>

<script>
export default {
  name: 'ConfidentialityRules',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'src/assets/styles/variables';
  .this-confidentiality-rules {
  }
</style>
